import React from "react"
import styled from "styled-components"
import theme from "@src/styles/theme"
import { StaticImage } from "gatsby-plugin-image"

const MediaWrapper = styled.div`
  display: none;

  width: calc(100% + 36px);
  flex-direction: column;

  @media (max-width: 1024px) {
    display: flex;
  }

  translate: -18px 0;
`

const MediaTrack = styled.div`
  background: ${theme.blackShade};
  width: 100%;
  height: 68px;
  display: flex;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 1440px) {
    max-width: 1440px;
  }

  @media (max-width: 1024px) {
    padding: 0 16px;
    justify-content: flex-start;
  }
`

const LogoHolders = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 67px;
  width: 100%;
  max-width: 1280px;
  @media (max-width: 1440px) {
    max-width: 1140px;
  }

  @media (max-width: 1260px) {
    max-width: 960px;
  }

  @media (max-width: 1024px) {
    min-width: 1100px;
    justify-content: flex-start;

    max-width: max-content;
  }

  @media (max-width: 600px) {
    justify-content: flex-start;

    gap: 32px;
  }
`

function Media() {
  return (
    <MediaWrapper>
      <MediaTrack>
        <LogoHolders>
          <StaticImage
            src="https://d3owbckoeihl9o.cloudfront.net/images/static-images/tour-page/logos/National-Geographic.png"
            alt="National Geographic"
            width={78}
            height={28}
          />

          <StaticImage
            src="https://d3owbckoeihl9o.cloudfront.net/images/static-images/tour-page/logos/guardian.png"
            alt="Guardian"
            width={68}
            height={22}
          />

          <StaticImage
            src="https://d3owbckoeihl9o.cloudfront.net/images/static-images/tour-page/logos/fodors-travel.png"
            alt="FodorsTravel"
            width={96}
            height={17}
          />

          <StaticImage
            src="https://d3owbckoeihl9o.cloudfront.net/images/static-images/tour-page/logos/time.png"
            alt="Time"
            width={75}
            height={24}
          />

          <StaticImage
            src="https://d3owbckoeihl9o.cloudfront.net/images/static-images/tour-page/logos/backpacker.png"
            alt="Backpacker"
            width={123}
            height={20}
          />

          <StaticImage
            src="https://d3owbckoeihl9o.cloudfront.net/images/static-images/tour-page/logos/National-Geographic.png"
            alt="National Geographic"
            width={78}
            height={28}
          />

          <StaticImage
            src="https://d3owbckoeihl9o.cloudfront.net/images/static-images/tour-page/logos/guardian.png"
            alt="Guardian"
            width={68}
            height={22}
          />
          <div></div>
        </LogoHolders>
      </MediaTrack>
    </MediaWrapper>
  )
}

export default Media
